export interface BlogArticle {
  id: number
  title: string
  excerpt: string
  date: string
  author: string
  category: string
  slug: string
  image: string
  content?: string
}

export const blogArticles: BlogArticle[] = [
  {
    id: 10,
    title: 'What Do You Whisper to the Machine?',
    excerpt:
      'Before an AI system answers a question, it sits idle. Cold. Dark. Silent. That instant—before the first token is produced—is where outcomes are decided. It is also the moment most enterprises leave to chance.',
    date: 'February 3, 2026',
    author: 'Drew Rayman',
    category: 'Pre-Flight',
    slug: 'what-do-you-whisper-to-the-machine',
    image:
      'https://cdn.magicpatterns.com/uploads/8DJsG4XP3cCcsrQ9GE4FdK/HEROwhisper.png',
  },
  {
    id: 9,
    title: 'January 2026 Changed the Rules for Enterprise AI',
    excerpt:
      'In January 2026, regulators made something unmistakably clear: the next phase of AI adoption is not about better models or more impressive demos. It is about governance that exists before AI acts.',
    date: 'February 3, 2026',
    author: 'ChatGPT',
    category: 'ChatGPT Pulse',
    slug: 'january-2026-changed-rules-enterprise-ai',
    image:
      'https://cdn.magicpatterns.com/uploads/x22HAimNrzY5ZgJpoUovZJ/8dcb5693-df9f-4764-b2d3-abc52d4b051a.webp',
  },
  {
    id: 8,
    title: 'Why "Time Saved" Is the Wrong Metric for AI ROI',
    excerpt:
      "Here's what the emerging evidence landscape is showing about why measuring real, audited outcomes — not just optimistic time-saved estimates — is becoming absolutely critical for investors and pilot sponsors.",
    date: 'February 2, 2026',
    author: 'ChatGPT',
    category: 'ChatGPT Pulse',
    slug: 'time-saved-wrong-metric-ai-roi',
    image:
      'https://cdn.magicpatterns.com/uploads/d3gtAQKcfedG7EeV5i9y5R/00375e1f-8aef-4897-86dc-7e31c79871f7.webp',
  },
  {
    id: 7,
    title: 'Why Agents Fail',
    excerpt:
      "Modern AI puts infinite context at your fingertips. But context without control leads to answers that sound confident and still miss what matters. Here's why enterprises need governed reasoning.",
    date: 'January 15, 2026',
    author: 'Drew Rayman',
    category: 'Agentic Systems',
    slug: 'new-article-template',
    image:
      'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&h=400&fit=crop',
  },
  {
    id: 1,
    title: 'Access Is Not Intelligence',
    excerpt:
      "Modern AI gives you access to everything. But access without judgment produces answers that sound right and still miss what matters. Here's why enterprises need more than information to trust AI outputs.",
    date: 'January 03, 2026',
    author: 'Drew Rayman',
    category: 'Contextual Intelligence',
    slug: 'access-not-intelligence',
    image:
      'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&h=400&fit=crop',
  },
  {
    id: 2,
    title: 'With AI, 8 out of 10 Good Answers is a Liability',
    excerpt:
      'In consumer AI, an 80 percent success rate feels impressive. In the enterprise, it is unacceptable. Eight out of ten good answers means two silent failures.',
    date: 'January 2, 2026',
    author: 'Drew Rayman',
    category: 'Enterprise AI',
    slug: 'generic-to-genetic-corporate-genome',
    image:
      'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=800&h=400&fit=crop',
  },
  {
    id: 3,
    title: 'Why Frontier Models Should Not Own Your Logic',
    excerpt:
      'Every enterprise AI stack today is described in three layers: the model, the data, and the application. But there is a fourth layer that determines whether any of it actually works at scale.',
    date: 'January 5, 2025',
    author: 'Neil Chinai',
    category: 'Instruction Layer',
    slug: 'instruction-layer-missing-infrastructure',
    image:
      'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=400&fit=crop',
  },
  {
    id: 4,
    title: 'Why Enterprise AI Fails—and Where the Advantage Actually Lives',
    excerpt:
      'Enterprises have invested billions in artificial intelligence infrastructure. And yet, the results remain inconsistent. Outputs require revision. Compliance teams remain uneasy.',
    date: 'December 28, 2024',
    author: 'Alex Ruiz',
    category: 'White Paper',
    slug: 'guardrails-that-work-framework',
    image:
      'https://images.unsplash.com/photo-1639322537228-f710d846310a?w=800&h=400&fit=crop',
  },
  {
    id: 5,
    title: 'EXECUTIVE ABSTRACT: The Instruction Layer',
    excerpt:
      'Despite massive capital deployment, corporate adoption of generative AI has outpaced its economic returns. This paper proposes a foundational shift in how enterprises architect AI.',
    date: 'December 20, 2025',
    author: 'Mike Mazar',
    category: 'Executive Abstract',
    slug: 'model-independence-context-outlives-llm',
    image:
      'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=800&h=400&fit=crop',
  },
  {
    id: 6,
    title: "AI's trillion-dollar opportunity: Context graphs",
    excerpt:
      'The shift toward agent-driven workflows has reopened a foundational question in enterprise software: what remains canonical when the interface to work changes?',
    date: 'December 22, 2025',
    author: 'Jaya Gupta, Ashu Garg',
    category: 'Perspectives',
    slug: 'tacit-knowledge-not-capturing',
    image:
      'https://cdn.magicpatterns.com/uploads/jutkoY5BnQcsqP5AymdLhG/Screenshot_2026-01-03_at_11.00.52_PM.png',
  },
]
